import { jsx } from "panel";
import { AsyncButtonEl } from "common/components/async-button";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { CheckboxEl } from "common/components/checkbox";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement } from "common/components/tooltip/types";
import { CheckboxListEl } from "../checkbox-list";
export function template() {
  const planOption = (planType) => /* @__PURE__ */ jsx("div", { sel: ".block", "data-sentry-component": "planOption", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CheckboxEl, { sel: ".plan-type-checkbox", attrs: {
    disabled: !this.helpers.canCancelPlan(planType),
    checked: this.state.planTypes[planType]
  }, on: {
    click: () => this.helpers.updatePlanTypes(planType)
  }, "data-sentry-element": "CheckboxEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".plan-description", class: {
    disabled: !this.helpers.canCancelPlan(planType)
  } }, /* @__PURE__ */ jsx("h2", { sel: ".field-title" }, planType, " Plan"), this.helpers.getPlanDescription(planType)));
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".cancel-modal", attrs: {
    closeable: false,
    open: this.isAttributeEnabled("open"),
    "confirm-button-label": "Confirm",
    "confirm-button-disabled": this.state.loading
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.helpers.getModalHeader())), /* @__PURE__ */ jsx("div", { sel: ".input-form" }, /* @__PURE__ */ jsx("div", { sel: ".inner-wrapper" }, this.state.loading ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(null, null, this.attr("request-type") === "downgrade_type" ? /* @__PURE__ */ jsx("div", { sel: ".row" }, "Your account will remain active and will automatically be moved to a Free plan after this billing period.") : /* @__PURE__ */ jsx("div", { sel: ".row" }, "Users will maintain access to your organization for ", this.attr("days-to-churn"), " days, after which it will be deleted. After ", this.attr("days-to-churn"), " days, organization projects will be", " ", /* @__PURE__ */ jsx("strong", null, "permanently"), " deleted."), this.attr("is-legacy") && /* @__PURE__ */ jsx("div", { sel: ".row.plan-types-row", class: {
    disabled: this.attr("request-type") !== "downgrade_type"
  } }, planOption("events"), planOption("people"), this.state.validationType === "plan" && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error
  } }, this.state.validationMessage)), this.helpers.shouldShowSurvey() && /* @__PURE__ */ jsx("div", { sel: ".row" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "Reasons for cancellation (select all that apply):"), /* @__PURE__ */ jsx(CheckboxListEl, { attrs: {
    items: this.helpers.getReasonOptions(),
    "show-select-all": 0,
    "num-columns": 2
  }, on: {
    clickItem: (ev) => this.helpers.selectedReason(ev.detail.item)
  } }), this.state.validationType === "reason" && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error
  } }, this.state.validationMessage), this.helpers.shouldShowFeatureInput() && /* @__PURE__ */ jsx("div", { sel: ".section" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "What features were missing?"), /* @__PURE__ */ jsx(InputEl, { sel: ".form-entry-textarea", attrs: {
    type: "textarea"
  }, on: {
    input: this.helpers.updateFeatureInput
  } }), this.state.validationType === "feature" && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error
  } }, this.state.validationMessage)), /* @__PURE__ */ jsx("div", { sel: ".section" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "What will you do for analytics going forward?"), /* @__PURE__ */ jsx(SelectEl, { sel: ".form-entry-dropdown", attrs: {
    options: this.helpers.ANALYTICS_ALTERNATIVES,
    "selected-option": this.state.alternativesValue
  }, on: {
    change: this.helpers.updateAlternatives
  } }), this.state.validationType === "analytics" && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error,
    placement: Placement.Right
  } }, this.state.validationMessage)), this.helpers.shouldShowVendor() && /* @__PURE__ */ jsx("div", { sel: ".section" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "Which vendor?"), /* @__PURE__ */ jsx(SelectEl, { sel: ".form-entry-dropdown", attrs: {
    options: this.helpers.COMPETITORS,
    "selected-option": this.state.selectedVendor,
    "menu-height": 133
  }, on: {
    change: this.helpers.updateCompetitor
  } })), this.helpers.shouldShowVendorInput() && /* @__PURE__ */ jsx("div", { sel: ".section" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "Please enter the name of the vendor here:"), /* @__PURE__ */ jsx(InputEl, { sel: ".form-entry-textarea", on: {
    input: this.helpers.updateVendorInput
  } }), this.state.validationType === "vendor" && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error
  } }, this.state.validationMessage)), /* @__PURE__ */ jsx("div", { sel: ".section" }, /* @__PURE__ */ jsx("div", { sel: ".form-title" }, "Would you like to add anything else?"), /* @__PURE__ */ jsx(InputEl, { sel: ".form-entry-textarea", attrs: {
    type: "textarea"
  }, on: {
    input: this.helpers.updateAdditionalInfo
  } }))))), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-bottom-buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", on: {
    click: this.helpers.handleCancel
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Cancel"), /* @__PURE__ */ jsx(AsyncButtonEl, { sel: ".mp-modal-button", params: {
    asyncAction: this.helpers.handleSubmit,
    theme: ButtonTheme.Primary
  }, "data-sentry-element": "AsyncButtonEl", "data-sentry-source-file": "template.tsx" }, "Submit"))));
}
